import { inject, Injectable, signal } from '@angular/core';
import { IUser } from '../interfaces/user.interface';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Toster, ToasterData } from '../components/toster/toster';

@Injectable({
  providedIn: 'root'
})

export class CommonService {

  private userDetailSignal = signal<IUser>({ userName: '', name: '' });
  public userDetail: any = this.userDetailSignal.asReadonly();

  public isAdminSignal = signal<boolean>(localStorage.getItem('admin') === 'true');
  public isAdmin: any = this.isAdminSignal.asReadonly();

  public isAuthenticatingSignal = signal<any>(false);
  public isAuthenticating: any = this.isAuthenticatingSignal.asReadonly();

  // Signal to control sidenav visibility
  private sidenavVisibleSignal = signal<boolean>(true);
  public sidenavVisible: any = this.sidenavVisibleSignal.asReadonly();
  public reportData:any;

  cRoles: string[] = [];

  roles: string[] = [
    'NMAFSM.Admin',
    'NMAFSM.DataEntry',
    'NMAFSM.ReportViewer',
    'NMAFSM.ReportsAndData'
  ]

  ObservationTypeList: string[] = [
    "",
    "Pre Hookup",
    "Hookup",
    "Pre RFC",
    "Equipment Set",
    "RFC",
    "Post RFC",
    "Remarks",
  ];
  ObservationTypeElevationdataList: string[] = [
    "Pre Hookup",
    "Hookup",
    "Pre RFC",
    "Equipment Set",
    "RFC",
    "Post RFC",
    "Remediation",
  ];
 
  private _snackBar = inject(MatSnackBar);
  
  constructor( ) {
    // let cUser = localStorage.getItem('cachedCvxClaimsPrincipal');
    // this.cRoles = cUser ? JSON.parse(cUser)?.roles : [];
  }

  successMessage(message: string): void {
    const data: ToasterData = { message, type: 'success' };
    this._snackBar.openFromComponent(Toster, {
      data,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      duration: 3000,
      panelClass: ['success-snackbar', 'stacked-snackbar']
    });
  }

  errorMessage(message: string): void {
    const data: ToasterData = { message, type: 'error' };
    this._snackBar.openFromComponent(Toster, {
      data,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      duration: 5000,
      panelClass: ['error-snackbar', 'stacked-snackbar']
    });
  }

  getCurrentuser(): IUser {
    return this.userDetailSignal();
  }
  updateCurrentuser(user: IUser): void {
    this.userDetailSignal.set(user);
  }

  formatDateTime(dateValue: any): string {
    if (!dateValue) return '';

    const date = new Date(dateValue);
    if (isNaN(date.getTime())) return '';

    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();

    let hours = date.getHours();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // Convert 0 to 12

    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${month}/${day}/${year} ${hours}:${minutes}:${seconds} ${ampm}`;
  }

  FormatDate(dateValue: any, format: string = 'yyyy-MM-dd', includeTime: boolean = false): string {
    if (!dateValue) return '';

    const date = new Date(dateValue);
    if (isNaN(date.getTime())) return '';

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    let formattedDate = '';

    switch (format.toLowerCase()) {
      case 'yyyy-mm-dd':
        formattedDate = `${year}-${month}-${day}`;
        break;
      case 'mm/dd/yyyy':
        formattedDate = `${month}/${day}/${year}`;
        break;
      case 'dd/mm/yyyy':
        formattedDate = `${day}/${month}/${year}`;
        break;
      case 'mm-dd-yyyy':
        formattedDate = `${month}-${day}-${year}`;
        break;
      case 'dd-mm-yyyy':
        formattedDate = `${day}-${month}-${year}`;
        break;
      default:
        formattedDate = `${year}-${month}-${day}`;
    }

    if (includeTime) {
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      formattedDate += ` ${hours}:${minutes}:${seconds}`;
    }

    return formattedDate;
  }

  // Methods to control sidenav visibility
  setSidenavVisible(visible: boolean): void {
    this.sidenavVisibleSignal.set(visible);
  }

  checkPermission(role: string[]): boolean {
    if (this.cRoles?.length) {
      return role.some(r => this.cRoles.includes(r));
    } else {
      // const cUser = localStorage.getItem('cachedCvxClaimsPrincipal');
      // this.cRoles = cUser ? JSON.parse(cUser)?.roles : [];
      return role.some(r => this.cRoles.includes(r));
    };
  }

  // toggleSidenav(): void {
  //   this.sidenavVisibleSignal.update(visible => !visible);
  // }

    downloadFile(blob: Blob, fileName: string) {
    // Check if we're in a browser environment
    if (typeof window !== 'undefined' && window.document) {
      // Modern browsers
      if ((navigator as any).msSaveBlob) {
        // IE 10+
        (navigator as any).msSaveBlob(blob, fileName);
      } else {
        // Other browsers
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        
        link.href = url;
        link.download = fileName;
        link.style.display = 'none';
        
        document.body.appendChild(link);
        link.click();
        
        // Clean up
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    }
  }

}